import React, { useCallback, useEffect, useState } from 'react';
import CustomBreadcrumbs from '../../../../../../common/components/custombreadcrumbs/CustomBreadcrumbs';
import {
  Box,
  Typography,
  IconButton,
  Tooltip,
  Menu,
  MenuItem,
  Dialog,
  Switch
} from '@mui/material';
import * as yup from 'yup';
import { Icon } from '@iconify/react';
import nodata from '../../../../../../app/assets/images/nodata.png.png';
import CustomDataGrid from '../../../../../../common/components/customized/customdatagrid/CustomDataGrid';
import {
  autoGeneratedBookingDeleteAction,
  autoGeneratedDeleteAction,
  autoGeneratedTripsAction,
  autoGenerateUpdateTripsAction,
  deleteSchedule,
  deleteScheduleBooking,
  driverDropdownAction,
  filterVehicleAction,
  getMainHotelsList,
  getScheduleDriverAction,
  getStandardVehicles,
  scheduleTripsAction,
  sicBookingsUpdate,
  switchTripsAction
} from '../../../../redux/reducer/autoPlannerSlices/autoGenerateSlice';
import { useAppDispatch, useAppSelector } from '../../../../../../app/redux/hooks';
import CustomButton from '../../../../../../common/components/buttons/CustomButton';
import UpdateScheduleTrip from '../UpdateScheduleTrip';
import UpdateGeneratedTrip from '../UpdateGeneratedTrip';
import {
  capitalizeFirstLetter,
  convertTo12HourFormat,
  debounce,
  formatISTtoTime
} from '../../../../../../utils/commonFunctions';
import CustomIconButton from '../../../../../../common/components/buttons/CustomIconButton';
import { useForm } from 'react-hook-form';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import CustomTextField from '../../../../../../common/components/customized/customtextfield/CustomTextField';
import { yupResolver } from '@hookform/resolvers/yup';
import CustomSelect from '../../../../../../common/components/customized/customselect/CustomSelect';
import AddExternalVehicle from './AddExternalVehicle';
import { GridActionsCellItem } from '@mui/x-data-grid';
import constant from '../../../../../../utils/constants';

interface Column {
  field: string;
  headerName: string;
  minWidth: number;
  flex: number;
  renderCell?: (params: { row: any }) => any;
  textAlign?: string;
}

interface Props {
  scheduleDate: number;
  checked: any;
  setBreadCrumbs: any;
  setVehicles: any;
  tripPayloads: any;
  agent: any;
  guest: any;
  tour: any;
  vehicle: any;
  initialLoad: boolean;
  setPayload: any;
}

interface Column {
  field: string;
  headerName: string;
  minWidth: number;
  flex: number;
  renderCell?: (params: { row: any }) => any;
  textAlign?: string;
}

interface SwitchColumn {
  field: string;
  headerName: string;
  minWidth: number;
  flex: number;
  renderCell?: (params: { row: any }) => any;
  textAlign?: string;
  align?: string;
}

interface PaginationModel {
  page: number;
  pageSize: number;
}

const ScheduledTsic = ({
  scheduleDate,
  checked,
  setBreadCrumbs,
  setVehicles,
  initialLoad,
  tripPayloads,
  agent,
  guest,
  tour,
  vehicle,
  setPayload
}: Props) => {
  const [pageSize, setPageSize] = useState(20);
  const [pageNo, setPageNo] = useState(1);
  const [filterPayload, setFilterPayload] = useState<any>('');
  const [only, setOnly] = React.useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedRow, setSelectedRow] = useState<any | null>(null);
  const [isDialog, setIsDialog] = useState('');
  const [driverPayload, setDriverPayload] = useState<any | null>(null);
  const [isUpdate, setIsUpdate] = useState(false);
  const [bookingUpdate, IsbookingsUpdate] = useState(false);
  const [tripData, setTripData] = useState<any[]>([]);
  const [prevSearch, setPrevSearch] = useState(false);
  const [scheduleData, setScheduleData] = useState<any[]>([]);
  const [view, setView] = useState<boolean>(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [selectedTripRow, setSelectedTripRow] = useState<any | null>(null);
  const [status, setStatus] = useState<string>('');
  const [transRow, setTransRow] = useState<any | null>(null);
  const [switchData, setSwitchData] = useState<any>([]);
  const [filter, setFilter] = useState('');
  const { data: role } = useAppSelector(state => state.auth);
  const [tripPayload, setTripPayload] = useState({ pageNo, pageSize });
  const [scheduledPayload, setScheduledPayload] = useState({
    autoplannerID: scheduleDate,
    pageNo: pageNo,
    pageSize: pageSize
  });
  const [isVehicle, setIsVehicle] = useState(true);
  const openMenu = Boolean(anchorEl);

  const reportData = useAppSelector(state => state.AutoGeneratedTrip);
  const [external, setExternal] = useState<boolean>(false);
  const [seatCapacity, setSeatCapacity] = useState<any>(0);
  const [isDrag, setIsDrag] = useState<boolean>(false);
  const scheduledData = useAppSelector(state => state.scheduleTrip);
  const Agents = useAppSelector(state => state.autoPlannerAgent.data || []);
  const Routes = useAppSelector(state => state.autoPlannerRoutes.data || []);
  const { isLoading } = useAppSelector(state => state.deleteSchedule);
  const { isLoading: getAllLoading } = useAppSelector(state => state.AutoGeneratedTrip);
  const { isLoading: autoBookingsLoading } = useAppSelector(state => state.scheduleTrip);
  const {
    data,
    count,
    isFilter,
    isLoading: switchTripLoading
  } = useAppSelector(state => state.switchTrip);
  const { isLoading: deleteLoading } = useAppSelector(
    state => state.deleteScheduleBooking
  );
  const { data: hotelLocation, isLoading: hotelLocationLoading } = useAppSelector(
    state => state.mainHotels
  );
  const { data: vehicleListData, isLoading: vehicleLoading } = useAppSelector(
    state => state.getStandardVehicles
  );
  const { isLoading: driverLoading } = useAppSelector(
    state => state.AutoGeneratedUpdateTrip
  );
  const transferDrivers = useAppSelector(state => state.Driverdrop || []);

  const { isLoading: updateisLoading } = useAppSelector(state => state.sicBookingsUpdate);
  let roletype = role?.role;
  const roleAgent = roletype === 'ROLE_AGENT';

  const tripSchema: any = () =>
    yup.object().shape({
      vehicle: yup
        .string()
        .oneOf(['internal', 'external'])
        .required('Select vehicle type')
        .default('internal'),

      search: yup.string().notRequired(),
      vehicleNumber: yup.string().when('vehicle', {
        is: 'internal',
        then: () => yup.string().required('Select vehicle number'),
        otherwise: () => yup.string().required('Select vehicle number')
      }),
      hotel: yup.string().required('Select Transfer Hotel'),
      driverName: yup.string().when('vehicle', {
        is: 'external',
        then: () => yup.string().required('Enter Driver Name'),
        otherwise: () => yup.string().notRequired()
      }),
      passengerCount: yup.string().when('vehicle', {
        is: 'external',
        then: () =>
          yup
            .number()
            .required('Enter Seat Capacity')
            .min(
              selectedRow?.netCount ? selectedRow?.netCount : 1,
              `Seat Capacity Must be Minimum ${selectedRow?.netCount}`
            )
            .typeError(`Seat Capacity Must be Minimum ${selectedRow?.netCount}`),
        otherwise: () => yup.string().notRequired()
      }),
      driverNumber: yup.string().when('vehicle', {
        is: 'external',
        then: () => yup.string().required('Enter Contact Number'),
        otherwise: () => yup.string().notRequired()
      })
    });

  const Driver = () =>
    yup.object().shape({
      driver: yup.string().required('Select Driver Name')
    });

  const {
    control,
    setValue,
    clearErrors,
    handleSubmit,
    getValues,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(tripSchema())
  });

  const {
    control: driverControl,
    handleSubmit: driverHandleSubmit,
    reset
  } = useForm({
    resolver: yupResolver(Driver())
  });

  const configuredRoute =
    Routes?.map((value: string) => ({
      id: value,
      label: value
    })) || [];

  const agentNames =
    Agents?.map((value: string) => ({
      id: value,
      label: capitalizeFirstLetter(value)
    })) || [];

  const payload = {
    ...scheduledPayload,
    PageNo: 1,
    PageSize: 20,
    autoplannerID: scheduleDate,
    tripMode: 'TSIC'
  };

  const dropDriver =
    transferDrivers?.data?.map((driver: any) => ({
      id: driver.driverID,
      label: capitalizeFirstLetter(driver.driverName)
    })) || [];

  const hotelLocationList = selectedTripRow
    ? selectedTripRow?.mainHotelResponses?.map((item: any) => ({
        id: item.coordinates.locationAddress,
        label: item.coordinates.locationAddress
      }))
    : transRow
    ? transRow?.mainHotelResponses?.map((item: any) => ({
        id: item?.coordinates.locationAddress,
        label: item?.coordinates.locationAddress
      }))
    : [];

  const vehicleList = vehicleListData?.map((item: any) => ({
    id: item,
    label: item?.toUpperCase()
  }));

  const dispatch = useAppDispatch();

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleViewTrip = (row: any) => {
    setView(true);
    if (row !== null) {
      const payload = {
        mode: 'TSIC',
        date: scheduleDate,
        tourName: row.tourName,
        vehicleNumber: row.vehicleNumber,
        id: row.id,
        isReturnTrip: row.isReturnTrip
      };
      dispatch(scheduleTripsAction(payload));
    }
    handleMenuClose();
    setIsDialog('');
  };

  const handleUpdateTrip = () => {
    IsbookingsUpdate(true);
    handleMenuClose();
  };

  const handleUpdateGroupTrip = () => {
    setIsUpdate(true);
    handleMenuClose();
  };

  const handleMenuClick = (row: any) => {
    setSelectedRow(row);
  };

  const handleAddTransfer = async (row: any) => {
    setIsDialog('addTransfer');
    setSelectedTripRow(row);

    const payload = {
      autoplannerID: scheduleDate,
      tripMode: 'TRANSFER',
      tourName: row?.tourName,
      totalPassengers: row?.totalCount,
      vehicleNumber: row?.vehicleNumber,
      journeyId: row?.journeyId
    };
    await dispatch(getStandardVehicles(payload));
  };

  const onChangeDriverSubmit = async (params: any) => {
    const payload = {
      ...selectedRow,
      ...driverPayload,
      modifyVehicleDriver: only ? 0 : 1,
      driverID: params.driver
    };

    const pageDetails = {
      autoplannerID: scheduleDate,
      tripMode: 'TSIC',
      id: selectedRow?.id
    };
    const data = { payload, pageDetails };

    if (checked) {
      await dispatch(autoGenerateUpdateTripsAction(data));
      handleClose();
    } else {
      const action = await dispatch(getScheduleDriverAction(payload));
      const paramss = { ...pageDetails, PageNo: pageNo, PageSize: pageSize };
      if (action.type === getScheduleDriverAction.fulfilled.type) {
        handleClose();
        setSelectedTripRow(null);

        await dispatch(switchTripsAction(paramss));

        handleClose();
        reset();
      }
    }
  };

  const handleMenuTripClick = (row: any) => {
    setSelectedTripRow(row);
  };

  const handleTransClick = (event: React.MouseEvent<HTMLElement>, row: any) => {
    setSelectedTripRow(null);
    setTransRow(row);
    setIsDialog('Transfer');
  };

  const handleClose = () => {
    setTransRow(null);
    setExternal(false);
    setAnchorEl(null);
    setIsDialog('');
  };

  const handleDeleteTrip = () => {
    handleMenuClose();
    if (isDialog === 'DeleteBooking' && selectedTripRow?.trip_id) {
      const payload = {
        row: selectedTripRow,
        group: selectedRow,
        pageDetails: {
          autoplannerID: scheduleDate,
          pageNo: pageNo,
          pageSize: pageSize
        }
      };
      dispatch(autoGeneratedBookingDeleteAction(payload));
    } else {
      if (selectedRow?.id) {
        const payload = {
          row: selectedRow,
          pageDetails: {
            autoplannerID: scheduleDate,
            pageNo: pageNo,
            pageSize: pageSize
          }
        };
        dispatch(autoGeneratedDeleteAction(payload));
      }
    }
  };

  const handleDelete = async () => {
    const payload = {
      mode: 'TSIC',
      date: scheduleDate,
      id: selectedRow?.id
    };
    const payloadBookings = {
      date: scheduleDate,
      journeyId: selectedTripRow?.journeyId || selectedTripRow?.journeyID,
      mode: 'TSIC',
      id: selectedRow?.id
    };
    const params = {
      autoplannerID: scheduleDate,
      tripMode: 'TSIC',
      PageNo: pageNo,
      PageSize: pageSize
    };
    if (isDialog === 'Delete') {
      await dispatch(deleteSchedule(payload));
    } else if (isDialog === 'DeleteBooking') {
      await dispatch(deleteScheduleBooking(payloadBookings));
      if (selectedTripRow?.source) {
        await dispatch(switchTripsAction(params));
      } else {
        await dispatch(
          scheduleTripsAction({
            date: scheduleDate,
            mode: 'TSIC',
            id: selectedRow?.id
          } as any)
        );
      }
    }
    setIsDelete(false);
    setIsDialog('');
  };

  const handleFilterChange = useCallback(
    debounce((event: string) => {
      setFilter(event);
      setPrevSearch(true);
      setBreadCrumbs((prev: any) => {
        return { ...prev, filter: event };
      });
      const payload = {
        autoplannerID: scheduleDate,
        tripMode: 'TSIC',
        PageNo: pageNo,
        PageSize: pageSize,
        searchFor: event,
        agentName: agent,
        guestName: guest,
        tourName: tour,
        vehicleNumber: vehicle
      };
      dispatch(switchTripsAction(payload));
    }),
    [scheduleDate, agent, guest, tour, vehicle]
  );

  //function to handle update transfer
  const handleUpdateTransfer = async () => {
    setIsDialog('addTransfer');
    // setValue(
    //   'vehicle',
    //   transRow?.transferInstance?.isExternalVehicle ? 'external' : 'internal'
    // );
    // setExternal(Boolean(transRow?.transferInstance?.isExternalVehicle));
    // setValue('driverName', transRow?.transferInstance?.driverName);
    // setValue('drivernumber', transRow?.transferInstance?.contactNumber);
    // setValue('passengerCount', transRow?.transferInstance?.totalCount);
    // setValue('vehicleNumber', transRow?.transferInstance?.vehicleNumber);
    // setValue('hotel', transRow?.transferInstance?.to?.locationAddress);
    // setExternal(Boolean(transRow?.transferInstance.isExternalVehicle));

    const payload = {
      autoplannerID: scheduleDate,
      journeyId: transRow.journeyId,
      tripMode: 'TRANSFER',
      tourName: transRow?.tourName,
      totalPassengers: transRow?.totalCount,
      vehicleNumber: transRow?.vehicleNumber
    };

    await dispatch(getStandardVehicles(payload));
  };

  const onSubmit = async (params: any) => {
    const selectedTrip = selectedTripRow ? selectedTripRow : transRow;
    const filteredVehicle = selectedTrip?.mainHotelResponses?.find(
      (item: any) => item?.coordinates?.locationAddress === params?.hotel
    );
    let payload: any = {
      id: selectedTrip.id,
      agentName: selectedTrip.agentName,
      guestName: selectedTrip.guestName,
      source: selectedTrip.source,
      startLat: selectedTrip.startLat,
      startLng: selectedTrip.startLng,
      destination: selectedTrip.destination,
      endLat: selectedTrip.endLat,
      endLng: selectedTrip.endLng,
      time: formatISTtoTime(selectedTrip.time),
      childCount: selectedTrip.childCount,
      adultCount: selectedTrip.adultCount,
      refNumber: selectedTrip.refNumber,
      vehicleNumber: selectedTrip.vehicleNumber,
      driverName: selectedTrip.driverName,
      isExternalVehicle: selectedTrip?.isExternalVehicle,
      // externalVehicleView: external
      //   ? null
      //   : {
      //       vehicleNumber: params.vehicleNumber,
      //       driverName: params.driverName,
      //       mobileNumber: params.driverNumber,
      //       driverID: `${params?.driverName}-${params?.driverNumber}`,
      //       isExternalVehicle: 1,
      //       seatingCapacity: params.passengerCount,
      //       isActive: selectedTrip?.externalVehicleView?.isActive
      //     },
      transferInstance: {
        vehicleNumber: params?.vehicleNumber,
        mainCoachPickupTime: filteredVehicle?.mainCoachPickupTime,
        to: {
          locationAddress: filteredVehicle?.coordinates?.locationAddress,
          lat: filteredVehicle?.coordinates?.lat,
          lng: filteredVehicle?.coordinates?.lng
        },
        isExternalVehicle: external ? 1 : 0,
        tourName: selectedTrip.tourName,
        totalCount: selectedTrip?.totalCount,
        seatingCapacity: params?.passengerCount,
        driverName: params?.driverName,
        contactNumber: params?.driverNumber
      },
      isReturnTrip: selectedTrip.isReturnTrip,
      tourName: selectedTrip.tourName,
      journeyId: selectedTrip.journeyId || selectedTrip.journeyID,
      mainCoachPickupTime: selectedTrip.mainCoachPickupTime
    };
    const pageDetails = {
      autoplannerID: scheduleDate,
      tripMode: 'TSIC',
      id: selectedTrip?.id
    };
    await dispatch(sicBookingsUpdate({ payload, pageDetails }));
    setIsDialog('');
    if (selectedTrip?.returnTime) {
      await dispatch(
        switchTripsAction({ ...pageDetails, PageNo: pageNo, PageSize: pageSize })
      );
    }
  };

  const handleDriver = (row: any) => {
    setSelectedRow(row);
    const payload = {
      mode: 'TSIC',
      date: scheduleDate,
      journeyId: row?.journeyId,
      vehicleNumber: row?.vehicleNumber,
      tourName: row?.tourName,
      modifyVehicleDriver: only ? 0 : 1,
      radio: only
    };
    setDriverPayload(payload);
    dispatch(driverDropdownAction(payload));
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    setOnly(isChecked);
    const payload = {
      ...driverPayload,
      radio: isChecked
    };
    dispatch(driverDropdownAction(payload));
  };

  const handlePaginationModelChange = async (newPaginationModel: PaginationModel) => {
    const { pageSize: newPageSize, page: newPageNo } = newPaginationModel;
    setPageSize(newPageSize);
    setPageNo(newPageNo + 1);
    const newPage = newPageNo + 1;
    const payload = {
      ...tripPayload,
      ...tripPayloads,
      PageNo: newPage,
      PageSize: newPageSize,
      autoplannerID: scheduleDate,
      tripMode: 'TSIC',
      searchFor: filter
    };
    setTripPayload(payload);
    if (checked && !view) await dispatch(autoGeneratedTripsAction(payload));
    else await dispatch(switchTripsAction(payload));
  };

  const Incolumns: Column[] = [
    {
      field: 'actions',
      headerName: 'Action',
      type: 'actions',
      minWidth: 100,
      maxWidth: 100,
      flex: 1,
      getActions: (params: any) => {
        const actions = [];

        if (!roleAgent) {
          actions.push(
            <GridActionsCellItem
              key='edit'
              icon={<Icon icon='ic:baseline-edit' className='menu-icon update' />}
              label={constant.Update}
              onClick={() => {
                handleMenuTripClick(params.row);
                handleUpdateTrip();
              }}
              showInMenu
            />
          );
        }

        return actions;
      }
    },
    { field: 'agentName', headerName: 'Agent Name', minWidth: 150, flex: 1 },
    {
      field: 'guestName',
      headerName: 'Guest Name',
      minWidth: 200,
      flex: 1,
      renderCell: (params: any) => (
        <Tooltip title={params.value || ''}>
          <span>{params.value}</span>
        </Tooltip>
      )
    },
    {
      field: 'guestContactNumber',
      headerName: 'Guest Contact Number',
      minWidth: 200,
      flex: 1,
      valueGetter: (params: any) => (params.value ? params.value : '-')
    },
    {
      field: 'source',
      headerName: 'Source',
      minWidth: 180,
      flex: 1,
      renderCell: (params: any) => (
        <Tooltip title={params.value || ''}>
          <span>{params.value}</span>
        </Tooltip>
      )
    },
    {
      field: 'destination',
      headerName: 'Destination',
      minWidth: 180,
      flex: 1,
      renderCell: (params: any) => (
        <Tooltip title={params.value || ''}>
          <span>{params.value}</span>
        </Tooltip>
      )
    },
    { field: 'time', headerName: 'Time', minWidth: 100, flex: 1 },
    { field: 'childCount', headerName: 'Child Count', minWidth: 120, flex: 1 },
    { field: 'adultCount', headerName: 'Adult Count', minWidth: 120, flex: 1 },

    {
      field: 'refNumber',
      headerName: 'Ref Number',
      minWidth: 150,
      flex: 1,
      renderCell: (params: any) => {
        const value = params.value;
        return value ? (
          <Tooltip title={value}>
            <span>{value}</span>
          </Tooltip>
        ) : (
          '-'
        );
      }
    },
    {
      field: 'vehicleNumber',
      headerName: 'Vehicle Number',
      minWidth: 100,
      flex: 1,
      renderCell: ({ value }: any) => value?.toUpperCase()
    },
    { field: 'driverName', headerName: 'Driver Name', minWidth: 150, flex: 1 },
    { field: 'mobileNumber', headerName: 'Contact Number', minWidth: 150, flex: 1 },
    {
      field: 'transfer',
      headerName: 'Transfer',
      minWidth: 150,
      flex: 1,
      renderCell: (params: any) => {
        const isDisabled = !params.row?.transferInstance;

        return (
          <Typography
            variant='body2'
            sx={{
              display: 'inline-block',
              cursor: isDisabled ? 'not-allowed' : 'pointer',
              color: isDisabled ? '#aaa' : '#fff',
              background: isDisabled
                ? 'linear-gradient(45deg, #e0e0e0 30%, #bdbdbd 90%)'
                : 'linear-gradient(45deg, #42a5f5 30%, #1e88e5 90%)',
              padding: '5px 10px',
              borderRadius: '20px',
              fontWeight: 'bold',
              textAlign: 'center',
              fontSize: '13px',
              boxShadow: isDisabled ? 'none' : '0 4px 6px rgba(0, 0, 0, 0.1)',
              transition: 'all 0.3s ease',
              '&:hover': {
                background: isDisabled
                  ? 'linear-gradient(45deg, #e0e0e0 30%, #bdbdbd 90%)'
                  : 'linear-gradient(45deg, #1e88e5 30%, #42a5f5 90%)',
                transform: isDisabled ? 'none' : 'scale(1.1)',
                boxShadow: isDisabled ? 'none' : '0 6px 10px rgba(0, 0, 0, 0.2)'
              },
              '&:active': {
                transform: isDisabled ? 'none' : 'scale(1.05)'
              }
            }}
            onClick={event => {
              if (!isDisabled) {
                // handleTransfer();
                handleTransClick(event, params.row);
              }
            }}
          >
            Transfer Details
          </Typography>
        );
      }
    }
  ].map((item: any) => ({ ...item, sortable: false }));

  const switchColumns: SwitchColumn[] = [
    {
      field: 'actions',
      headerName: 'Action',
      type: 'actions',
      minWidth: 100,
      maxWidth: 100,
      flex: 1,
      getActions: (params: any) => {
        const actions = [];

        if (!roleAgent) {
          actions.push(
            <GridActionsCellItem
              key='edit'
              icon={<Icon icon='ic:baseline-edit' className='menu-icon update' />}
              label={constant.Update}
              onClick={() => {
                handleMenuTripClick(params.row);
                handleUpdateTrip();
              }}
              showInMenu
            />
          );
        }

        return actions;
      }
    },
    { field: 'agentName', headerName: 'Agent Names', minWidth: 150, flex: 1 },
    {
      field: 'guestName',
      headerName: 'Guest Name',
      minWidth: 200,
      flex: 1,
      renderCell: (params: any) => (
        <Tooltip title={params.value || ''}>
          <span>{params.value}</span>
        </Tooltip>
      )
    },
    {
      field: 'guestContactNumber',
      headerName: 'Guest Contact Number',
      minWidth: 200,
      flex: 1,
      valueGetter: (params: any) => (params.value ? params.value : '-')
    },
    {
      field: 'source',
      headerName: 'Source',
      minWidth: 180,
      flex: 1,
      renderCell: (params: any) => (
        <Tooltip title={params.value || ''}>
          <span>{params.value}</span>
        </Tooltip>
      )
    },
    {
      field: 'destination',
      headerName: 'Destination',
      minWidth: 180,
      flex: 1,
      renderCell: (params: any) => (
        <Tooltip title={params.value || ''}>
          <span>{params.value}</span>
        </Tooltip>
      )
    },
    {
      field: 'returnTime',
      headerName: 'Return Time',
      minWidth: 130,
      flex: 1,
      renderCell: (params: any) => {
        const value = params.value;
        return value ? (
          <Tooltip title={value}>
            <span>{value}</span>
          </Tooltip>
        ) : (
          '-'
        );
      }
    },
    { field: 'childCount', headerName: 'Child Count', minWidth: 120, flex: 1 },
    { field: 'adultCount', headerName: 'Adult Count', minWidth: 120, flex: 1 },

    {
      field: 'refNumber',
      headerName: 'Ref Number',
      minWidth: 150,
      flex: 1,
      renderCell: (params: any) => {
        const value = params.value;
        return value ? (
          <Tooltip title={value}>
            <span>{value}</span>
          </Tooltip>
        ) : (
          '-'
        );
      }
    },
    {
      field: 'vehicleNumber',
      headerName: 'Vehicle Number',
      minWidth: 100,
      flex: 1,
      renderCell: ({ value }: any) => value?.toUpperCase()
    },
    {
      field: 'driverName',
      headerName: 'Driver Name',
      minWidth: 150,
      renderCell: (params: any) => {
        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              width: '100%'
            }}
          >
            {params?.row?.vehicleNumber != 'Unassigned' && !roleAgent && (
              <Icon
                icon='ph:user-switch'
                style={{
                  color: '#0ebc93',
                  cursor: 'pointer',
                  fontSize: '25px',
                  marginRight: '10px'
                }}
                className={'activeIcon'}
                onClick={event => {
                  event.stopPropagation();
                  setIsDialog('changeDriver');
                  handleDriver(params.row);
                }}
              />
            )}
            <Typography>{params?.value}</Typography>
          </Box>
        );
      },
      flex: 1
    },
    {
      field: 'driverContactNumber',
      headerName: 'Contact Number',
      minWidth: 150,
      flex: 1
    },
    {
      field: 'guideName',
      headerName: 'Guide Name',
      minWidth: 150,
      flex: 1,
      renderCell: (params: any) => {
        const value = params.value;
        return value ? (
          <Tooltip title={value}>
            <span>{value}</span>
          </Tooltip>
        ) : (
          '-'
        );
      }
    },
    {
      field: 'guideContactNumber',
      headerName: 'Guide Contact Number',
      minWidth: 170,
      flex: 1,
      renderCell: (params: any) => {
        const value = params.value;
        return value ? (
          <Tooltip title={value}>
            <span>{value}</span>
          </Tooltip>
        ) : (
          '-'
        );
      }
    },
    {
      field: 'transfer',
      headerName: 'Transfer',
      minWidth: 150,
      flex: 1,
      align: 'center',
      renderCell: (params: any) => {
        const isDisabled = !params.row?.transferInstance && !roleAgent;

        return params?.row?.isReturnTrip ||
          params?.row?.mainHotelResponses?.length === 0 ? (
          'NA'
        ) : (
          <Typography
            variant='body2'
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              color: '#fff',
              background: isDisabled
                ? 'linear-gradient(45deg, #66bb6a 30%, #43a047 90%)'
                : 'linear-gradient(45deg, #42a5f5 30%, #1e88e5 90%)',
              padding: '4px 10px',
              borderRadius: '20px',
              fontWeight: 'bold',
              textAlign: 'center',
              fontSize: '13px',
              minHeight: '24px',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
              transition: 'all 0.3s ease',
              '&:hover': {
                background: isDisabled
                  ? 'linear-gradient(45deg, #43a047 30%, #66bb6a 90%)'
                  : 'linear-gradient(45deg, #1e88e5 30%, #42a5f5 90%)',
                transform: 'scale(1.1)',
                boxShadow: '0 6px 10px rgba(0, 0, 0, 0.2)'
              },
              '&:active': {
                transform: 'scale(1.05)'
              }
            }}
            onClick={event => {
              if (isDisabled) {
                handleAddTransfer(params.row);
              } else {
                // handleTransfer();
                handleTransClick(event, params.row);
              }
            }}
          >
            {isDisabled ? 'Add Transfer' : 'Transfer Details'}
          </Typography>
        );
      }
    }
  ].map((item: any) => ({ ...item, sortable: false }));

  const columns: Column[] = [
    {
      field: 'actions',
      headerName: 'Action',
      type: 'actions',
      minWidth: 100,
      maxWidth: 100,
      flex: 1,
      getActions: (params: any) => {
        const actions = [
          <GridActionsCellItem
            key='delete'
            icon={
              <Icon
                icon='carbon:report'
                className='menu-icon view'
                style={{ color: '#FF4343' }}
              />
            }
            label={'Bookings'}
            onClick={() => {
              handleMenuClick(params.row);
              handleViewTrip(params.row);
            }}
            showInMenu
          />
        ];

        if (!roleAgent) {
          actions.push(
            <GridActionsCellItem
              key='edit'
              icon={<Icon icon='ic:baseline-edit' className='menu-icon update' />}
              label={constant.Update}
              onClick={() => {
                handleMenuClick(params.row);
                handleUpdateGroupTrip();
              }}
              showInMenu
            />
          );
        }

        return actions;
      }
    },
    { field: 'vehicleNumberUpper', headerName: 'Vehicle Number', minWidth: 200, flex: 1 },
    {
      field: 'tourName',
      headerName: 'Tour Name',
      minWidth: 250,
      flex: 1,
      renderCell: (params: any) => (
        <Tooltip title={params.value || ''}>
          <span>{params.value}</span>
        </Tooltip>
      )
    },
    {
      field: 'driverName',
      headerName: 'Driver Name',
      minWidth: 250,
      renderCell: (params: any) => {
        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              width: '100%'
            }}
          >
            {params.row.vehicleNumberUpper != 'Unassigned' && !roleAgent && (
              <Icon
                icon='ph:user-switch'
                style={{
                  color: '#0ebc93',
                  cursor: 'pointer',
                  fontSize: '25px',
                  marginRight: '10px'
                }}
                className={'activeIcon'}
                onClick={event => {
                  event.stopPropagation();
                  setIsDialog('changeDriver');
                  handleDriver(params?.row);
                }}
              />
            )}
            <Typography>{params?.value}</Typography>
          </Box>
        );
      },
      flex: 1
    },
    {
      field: 'driverContactNumber',
      headerName: 'Driver Contact Number',
      minWidth: 150,
      flex: 1
    },
    { field: 'pickupWindowView', headerName: 'Pickup Window', minWidth: 200, flex: 1 },
    {
      field: 'returnTimeView',
      headerName: 'Return Time',
      minWidth: 150,
      flex: 1,
      renderCell: (params: any) => {
        const value = params.value;
        return value ? (
          <Tooltip title={value}>
            <span>{value}</span>
          </Tooltip>
        ) : (
          '-'
        );
      }
    },
    { field: 'totalAdultCount', headerName: 'Adult Count', minWidth: 150, flex: 1 },
    { field: 'totalChildCount', headerName: 'Child Count', minWidth: 150, flex: 1 },
    { field: 'netCount', headerName: 'Total Count', minWidth: 150, flex: 1 }
  ].map((item: any) => ({ ...item, sortable: false }));

  useEffect(() => {
    const payload = {
      ...scheduledPayload,
      autoplannerID: scheduleDate,
      tripMode: 'TSIC',
      PageNo: pageNo,
      PageSize: pageSize
    };
    if (checked) {
      dispatch(autoGeneratedTripsAction(payload));
      // dispatch(filterVehicleAction(payload));
    } else {
      dispatch(switchTripsAction(payload));
      // dispatch(filterVehicleAction(payload));
    }
  }, []);

  useEffect(() => {
    setPageNo(1);
    setPageSize(20);
  }, [checked]);

  useEffect(() => {
    if ((reportData as any)?.data?.standardTourBookingInfo?.length > 0) {
      const updatedList = (reportData as any)?.data?.standardTourBookingInfo.map(
        (item: any, index: number) => {
          const [startTime, endTime] = item?.pickupWindow
            ? item?.pickupWindow?.split('-')
            : '';
          return {
            ...item,
            id: item.id,
            vehicleNumberUpper: item.vehicleNumber.toUpperCase(),
            pickupWindowView: startTime
              ? `${convertTo12HourFormat(startTime)} - ${convertTo12HourFormat(endTime)}`
              : '-',
            returnTimeView: item.returnTime ? convertTo12HourFormat(item.returnTime) : '-'
          };
        }
      );
      const vehicleNumbers = (reportData as any)?.data?.standardTourBookingInfo.map(
        (item: any) => item.vehicleNumber
      );
      setVehicles(vehicleNumbers);
      setTripData(updatedList);
    } else {
      setTripData([]);
    }
  }, [reportData]);

  useEffect(() => {
    if (
      scheduledData.data !== null &&
      scheduledData.data.data !== null &&
      scheduledData?.data.data !== undefined
    ) {
      const scheduleList = scheduledData?.data?.data?.map((item: any, index: number) => ({
        ...item,
        id: index + 1,
        isExternalVehicle: item?.isExternalVehicle,
        vehicleNumber: item.externalVehicleView?.vehicleNumber
          ? item.externalVehicleView?.vehicleNumber
          : item?.vehicleNumber,
        driverName: item.externalVehicleView?.driverName
          ? item.externalVehicleView?.driverName
          : item?.driverName,
        driverID: item.externalVehicleView?.driverID
          ? item.externalVehicleView?.driverID
          : item?.driverId,
        mobileNumber: item.externalVehicleView?.mobileNumber
          ? item.externalVehicleView?.mobileNumber
          : item?.driverContactNumber,
        isExternalVehicles: item.externalVehicleView?.isExternalVehicle
          ? item.externalVehicleView?.isExternalVehicle
          : item?.isExternalVehicle,
        seatingCapacity: item.externalVehicleView?.seatingCapacity
          ? item.externalVehicleView?.seatingCapacity
          : item?.seatingCapacitys,
        isActive: item?.externalVehicleView?.isActive
      }));

      setScheduleData(scheduleList);
    } else {
      setScheduleData([]);
    }
  }, [scheduledData]);

  useEffect(() => {
    if (data?.length > 0) {
      const switchList = data.map((item: any, index: number) => ({
        ...item,
        id: index + 1,
        totalCount: item.childCount + item.adultCount
      }));
      const vehicleNumbers = data?.map((item: any) => item.vehicleNumber);
      setVehicles(vehicleNumbers);
      setSwitchData(switchList);
    } else {
      setSwitchData([]);
      setVehicles([]);
    }
  }, [data]);

  useEffect(() => {
    setBreadCrumbs({
      setViews: setView,
      views: view
    });
  }, [view]);

  useEffect(() => {
    const filter = {
      autoplannerID: scheduleDate,
      tripMode: 'TSIC',
      PageNo: pageNo,
      PageSize: pageSize,
      agentName: agent,
      guestName: guest,
      tourName: tour,
      vehicleNumber: vehicle
    };
    setFilterPayload(filter);
  }, [agent, guest, tour, vehicle]);

  useEffect(() => {
    setPayload({ pageNo: pageNo, pageSize: pageSize });
  }, [pageNo, pageSize]);

  return (
    <Box>
      <CustomBreadcrumbs
        className='tracking-heading'
        itemOne={'Scheduled Tour'}
        itemTwo={'Bookings'}
        itemTwoState={view}
        setView={setView}
        handleItemOneClick={() => {
          if (view) dispatch(autoGeneratedTripsAction(payload));
        }}
      />

      {checked && (
        <Box>
          {(getAllLoading && tripData?.length == 0) ||
          (autoBookingsLoading && scheduleData?.length === 0) ? (
            <Box className='blue-circle-loader'>
              <Box className='blue-circle-spinner'></Box>
            </Box>
          ) : (reportData as any)?.data?.standardTourBookingInfo?.length > 0 && !view ? (
            <CustomDataGrid
              rows={tripData}
              onRowClick={(event: any, row) => {
                if (!roleAgent) {
                  handleUpdateGroupTrip();
                  setSelectedRow(row);
                }
              }}
              columns={columns}
              loading={getAllLoading}
              type={'noPageNation'}
              paginationMode={'client'}
            />
          ) : view ? (
            <CustomDataGrid
              rows={scheduleData}
              onRowClick={(event: any, row) => {
                if (!roleAgent) {
                  handleUpdateTrip();
                  setSelectedTripRow(row);
                }
              }}
              columns={Incolumns}
              loading={autoBookingsLoading}
              type={'noPageNation'}
              paginationMode={'client'}
            />
          ) : (
            <Box className='no-report-img'>
              <Box
                component={'img'}
                src={nodata}
                alt='No Report Found'
                className='no-report-found'
              />
            </Box>
          )}
        </Box>
      )}

      {!checked && (
        <Box>
          {switchTripLoading && switchData.length === 0 ? (
            <Box className='blue-circle-loader'>
              <Box className='blue-circle-spinner'></Box>
            </Box>
          ) : data?.length > 0 || filter || isFilter || prevSearch ? (
            <Box>
              <Box sx={{ display: 'flex', justifyContent: 'right', width: '100%' }}>
                <Box sx={{ width: 200 }}>
                  <CustomTextField
                    name='search'
                    control={control}
                    id='filter-input'
                    placeholder='Search...'
                    value={filter}
                    variant='standard'
                    icon={<SearchOutlinedIcon color='primary' />}
                    onChangeCallback={(e: any) => handleFilterChange(e)}
                  />
                </Box>
              </Box>
              <CustomDataGrid
                rows={switchData}
                columns={switchColumns}
                loading={switchTripLoading}
                rowCount={count}
                onRowClick={(event: any, row) => {
                  if (!roleAgent) {
                    handleUpdateTrip();
                    setSelectedTripRow(row);
                  }
                }}
                type='logistics'
                onPaginationModelChange={handlePaginationModelChange}
                pageNo={pageNo}
                pageSize={pageSize}
                paginationModel={{
                  page: pageNo ? pageNo - 1 : 0,
                  pageSize: pageSize ? pageSize : 5
                }}
              />
            </Box>
          ) : (
            <Box className='no-report-img'>
              <Box
                component={'img'}
                src={nodata}
                alt='No Report Found'
                className='no-report-found'
              />
            </Box>
          )}
        </Box>
      )}

      {isUpdate && (
        <UpdateScheduleTrip
          isUpdate={isUpdate}
          setIsUpdate={setIsUpdate}
          selectedRow={selectedRow}
          filterPayload={filterPayload}
          autoplannerID={scheduleDate}
          tripMode='TSIC'
        />
      )}

      {bookingUpdate && (
        <UpdateGeneratedTrip
          isOpen={bookingUpdate}
          filterPayload={filterPayload}
          setIsOpen={IsbookingsUpdate}
          selectedTripRow={selectedTripRow}
          setSelectedTripRow={setSelectedTripRow}
          selectedRow={selectedRow}
          pageDetail={{ pageNo: pageNo, pageSize: pageSize }}
          tripMode={'TSIC'}
          autoplannerID={scheduleDate}
          Agents={agentNames}
          Routes={configuredRoute}
        />
      )}

      {['Delete', 'share', 'DeleteBooking'].includes(isDialog) && (
        <Dialog
          open={
            isDialog === 'Delete' || isDialog === 'share' || isDialog === 'DeleteBooking'
          }
        >
          <Box
            sx={{
              textAlign: 'center',
              padding: '5%',
              minWidth: '350px'
            }}
          >
            <Typography>Are You Sure You Want To Delete the Trip</Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                paddingTop: '5%',
                justifyContent: 'center'
              }}
            >
              <Box sx={{ marginRight: '12px' }}>
                <CustomButton
                  className='saveChanges'
                  category='Yes'
                  loading={isDialog === 'Delete' ? isLoading : deleteLoading}
                  onClick={() => {
                    handleDelete();
                  }}
                />
              </Box>
              <CustomButton
                className='cancel'
                category='No'
                onClick={() => setIsDialog('')}
              />
            </Box>
          </Box>
        </Dialog>
      )}

      {isDialog === 'changeDriver' && (
        <Dialog
          open={isDialog === 'changeDriver'}
          onClose={handleClose}
          PaperProps={{
            sx: {
              borderRadius: 3,
              background: 'linear-gradient(to bottom, #ffffff, #f0f8ff)',
              boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.15)',
              overflow: 'hidden'
            }
          }}
        >
          <Box
            padding={3}
            width={400}
            component={'form'}
            onSubmit={driverHandleSubmit(onChangeDriverSubmit)}
          >
            <Typography sx={{ fontWeight: '600', fontSize: '18px' }}>
              Change Driver
            </Typography>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                marginTop: '5px',
                marginRight: '10px'
              }}
            >
              <Typography>Changes only applicable for this tour</Typography>
              <Switch
                checked={only}
                onChange={handleChange}
                inputProps={{ 'aria-label': 'controlled' }}
              />
            </Box>
            <CustomSelect
              id='driver'
              control={driverControl}
              name='driver'
              label='Driver Name'
              placeholder='Select Driver Name'
              options={dropDriver}
              loading={transferDrivers.isLoading}
            />
            <Box sx={{ textAlign: 'right', padding: '10px' }}>
              <CustomButton
                category='Cancel'
                className='cancel'
                sx={{ marginRight: '10px' }}
                onClick={() => handleClose()}
              />
              <CustomButton
                category={'Save'}
                className='saveChanges'
                type='submit'
                loading={driverLoading}
              />
            </Box>
          </Box>
        </Dialog>
      )}
      {isDialog === 'Transfer' && (
        <Dialog
          open={isDialog === 'Transfer'}
          onClose={handleClose}
          PaperProps={{
            sx: {
              borderRadius: 3,
              background: 'linear-gradient(to bottom, #ffffff, #f0f8ff)',
              boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.15)',
              overflow: 'hidden'
            }
          }}
        >
          <Box padding={3} width={400} position='relative'>
            <Box
              className='closeIcon icon-position d-flex close-icon-index'
              onClick={handleClose}
            >
              <CustomIconButton category='CloseValue' />
            </Box>

            <Typography
              variant='h6'
              sx={{
                marginBottom: 2,
                fontWeight: 'bold',
                color: '#333',
                textAlign: 'center',
                textTransform: 'uppercase',
                borderBottom: '2px solid #007bff',
                paddingBottom: 1
              }}
            >
              Transfer Details
            </Typography>

            <Box sx={{ marginY: 2 }}>
              <Typography variant='body1' sx={{ fontSize: '1rem', color: '#555' }}>
                <strong>Transfer From:</strong>{' '}
                {transRow?.transferInstance?.from?.locationAddress}
              </Typography>
            </Box>

            <Box sx={{ marginY: 2 }}>
              <Typography variant='body1' sx={{ fontSize: '1rem', color: '#555' }}>
                <strong>Transfer To:</strong>{' '}
                {transRow?.transferInstance?.to?.locationAddress}
              </Typography>
            </Box>

            <Box sx={{ marginY: 2 }}>
              <Typography variant='body1' sx={{ fontSize: '1rem', color: '#555' }}>
                <strong>Total Count:</strong> {transRow?.transferInstance?.totalCount}
              </Typography>
            </Box>

            <Box sx={{ marginY: 2 }}>
              <Typography variant='body1' sx={{ fontSize: '1rem', color: '#555' }}>
                <strong>Driver Name:</strong> {transRow?.transferInstance?.driverName}
              </Typography>
            </Box>

            <Box sx={{ marginY: 2 }}>
              <Typography variant='body1' sx={{ fontSize: '1rem', color: '#555' }}>
                <strong>Contact Number:</strong>{' '}
                {transRow?.transferInstance?.contactNumber}
              </Typography>
            </Box>

            <Box sx={{ marginY: 2 }}>
              <Typography variant='body1' sx={{ fontSize: '1rem', color: '#555' }}>
                <strong>Vehicle Number:</strong>{' '}
                {transRow?.transferInstance?.vehicleNumber.toUpperCase()}
              </Typography>
            </Box>
            <CustomButton
              category='Update'
              className='saveChanges'
              sx={{ right: 10, position: 'absolute', bottom: 10 }}
              onClick={() => {
                handleUpdateTransfer();
              }}
            />
          </Box>
        </Dialog>
      )}

      {isDialog === 'addTransfer' && (
        <AddExternalVehicle
          selectedRow={selectedTripRow}
          isDialog={isDialog}
          transRow={transRow}
          setTransRow={setTransRow}
          setAnchorEl={setAnchorEl}
          setIsDialog={setIsDialog}
          hotelLocationList={hotelLocationList}
          vehicleList={vehicleList}
          tripMode={'TSIC'}
          scheduleDate={scheduleDate}
        />
      )}
    </Box>
  );
};

export default ScheduledTsic;
